import Icon from '@/components/icon/Icon';
import clsx from 'clsx';
import { ButtonProps } from '@/components/button/types'; // Adjust path as needed
import { getButtonClasses, getPaddingClass } from './const';
import { renameDomProps } from '@/utils/sanitizeDomProps';

export function Button({
  name,
  onClick,
  variant = 'primary',
  sizes = 'medium',
  leftIcon,
  rightIcon,
  reverse = false,
  disabled = false,
  theme = 'light',
  type = 'button',
  className,
  classNameSpan,
  ...rest
}: ButtonProps) {
  const { resolvedVariantClass, resolvedSizeClass, iconOnlyPaddingClass } =
    getButtonClasses({
      variant,
      sizes,
      theme,
      name,
      leftIcon,
      rightIcon,
      disabled,
    });

  const paddingClass = getPaddingClass({ name, leftIcon, rightIcon });

  const buttonClass = clsx(
    'smzh-btn flex items-center gap-2 rounded-lg',
    resolvedVariantClass,
    iconOnlyPaddingClass || resolvedSizeClass,
    paddingClass,
    disabled ? 'cursor-not-allowed opacity-50' : '',
    className,
  );
  const renamedProps = renameDomProps(rest);
  return (
    <button
      data-component-id="COO4"
      className={`smzh-btn ${buttonClass} ${className}`}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      aria-disabled={disabled}
      aria-label={`smzh-${name ?? 'button'}`}
      type={type}
      {...renamedProps}
    >
      <span
        className={clsx(
          'flex items-center justify-center gap-2',
          classNameSpan,
        )}
      >
        {leftIcon && <Icon {...leftIcon} />}
        {name && <span>{name}</span>}
        {rightIcon && <Icon {...rightIcon} />}
      </span>
    </button>
  );
}
